import { Component, OnInit } from '@angular/core';
import { WebUserService } from '../../../services/webuser.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { FilterService } from '../../../services/filter.service';

@Component({
  selector: 'app-webusers',
  templateUrl: './webusers.component.html',
  styleUrls: ['./webusers.component.scss']
})
export class WebusersComponent implements OnInit {
  loading: boolean = false;
  rows = [];

  filter: any = {
    company_Id: undefined,
    location_Id: undefined,
    name: '',
    email: ''
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));
  constructor(private webUsersService: WebUserService, public router: Router, private authService: AuthService, private filterService: FilterService) {
    if (this.authService.currentUser.value.userProfileId != 1) {
      //user is a client, so throw them to the reports page
      this.router.navigate(['reports/rote']);
    }
    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null) {
      this.filter = filters;
      this.loadTable()
    }
  }

  ngOnInit(): void {
    this.loadTable();
  }

  loadTable() {
    this.loading = true;
    this.webUsersService.getTable(this.filter.company_Id, this.filter.location_Id, this.filter.name, this.filter.email).then((rows) => {
      this.rows = rows;
      this.loading = false;
    });
  }

  rebind() {
    this.loadTable();
  }
  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.loadTable();
  }

  setPage(pageInfo) {
 
    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }
    this.loadTable();

  }
  onCompanyChange(value) {
    this.filter.location_Id = 0;

    if (value == undefined)
      this.filter.company_Id = undefined;
    else
      this.filter.company_Id = value.id;

  }

  onLocationChange(value) {
    if (value == undefined)
      this.filter.location_Id = undefined;
    else
      this.filter.location_Id = value.id;

  }

  add() {
    this.router.navigate(['users/manage']);
  }


}
